import React from "react";
import Grid from "@material-ui/core/Grid";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import RadonLevelRangeImg from "../assets/img/guide1.png";
import GreenRangeImg from "../assets/img/guide_green.png";
import OrangeRangeImg from "../assets/img/guide_yellow.png";
import RedRangeImg from "../assets/img/guide_red.png";
import Space from "./Space";

// 사용자 정의 스타일 (모바일 반응형 포함)
const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    overflowX: "hidden", // 가로 스크롤바 방지
    width: "100%",
    maxWidth: "600px", // 오버플로우 방지를 위한 최대 너비 제한
    margin: "0 auto", // 다이얼로그 콘텐츠 중앙 정렬
    boxSizing: "border-box",
    borderRadius: "16px", // 둥근 모서리 유지
  },
  dialogTitle: {
    fontFamily: "Roboto, sans-serif",
    fontWeight: 800,
    fontSize: "14px",
    color: "#1A3C5E",
    textAlign: "center",
    padding: "26px 24px 34px 24px", // 위 10px, 아래 10px 추가 패딩
    marginTop: "0px", // 추가 상단 마진 제거
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: "18px 16px 26px 16px", // 작은 화면에서 위 10px, 아래 10px 추가 패딩
    },
  },
  dialogContentTop: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "14px",
    color: "#1A3C5E",
    textAlign: "center",
    padding: "0 24px 10px", // 고정 패딩
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: "0 16px 8px",
    },
  },
  dialogContent: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "16px",
    color: "#1A3C5E",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  rangeTitle: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "16px",
    fontWeight: 700,
    color: "#1A3C5E",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  bulletText: {
    marginTop: "8px",
    marginBottom: "8px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "4px",
      marginBottom: "4px",
    },
  },
  closeButton: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "14px",
    color: "#62B3E1",
    borderColor: "#62B3E1",
    textTransform: "none",
    width: "200px",
    borderRadius: "8px",
    padding: "8px 24px", // 고정 패딩
    [theme.breakpoints.down("sm")]: {
      width: "150px",
      fontSize: "12px",
      padding: "8px 16px",
    },
  },
  dialogActions: {
    padding: "0 24px 26px", // 하단 10px 추가 패딩
    display: "flex",
    justifyContent: "center", // 버튼 중앙 정렬
    [theme.breakpoints.down("sm")]: {
      padding: "0 16px 18px", // 작은 화면에서 하단 10px 추가 패딩
    },
  },
  buttonContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "16px", // 고정 마진
    marginBottom: "0px", // 추가 하단 마진 제거
  },
  levelBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
  },
  levelMarker: {
    fontSize: "12px",
    color: "#1A3C5E",
    margin: "0 5px",
  },
  levelLine: {
    flexGrow: 1,
    height: "4px",
    background: "linear-gradient(to right, #00FF00, #FFA500, #FF0000)",
  },
  rangeContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    marginBottom: "16px",
    paddingLeft: "24px", // 좌측 패딩
    paddingRight: "24px", // 우측 패딩
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
  rangeIcon: {
    height: "10px",
    marginRight: "16px",
    marginLeft: "16px", // 좌측 마진 추가로 좌우 균형
    marginTop: "6px",
    [theme.breakpoints.down("sm")]: {
      marginRight: "12px",
      marginLeft: "12px",
    },
  },
  rangeTextContainer: {
    flex: 1,
  },
  rangeImageTop: {
    width: "70%",
    maxWidth: "70%",
    height: "auto",
    display: "block",
    margin: "0 auto",
    paddingLeft: "24px",
    paddingRight: "24px",
    [theme.breakpoints.down("lg")]: {
      width: "70%",
      maxWidth: "70%",
    },
    [theme.breakpoints.down("md")]: {
      width: "60%",
      maxWidth: "60%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "65%",
      maxWidth: "65%",
      paddingLeft: "16px",
      paddingRight: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      maxWidth: "100%",
    },
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    marginBottom: "16px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "8px",
    },
  },
}));

const RadonLevelsGuideDialog = ({ handleClose }) => {
  const classes = useStyles();

  return (
    <Box className={classes.dialogContainer}>
      <DialogTitle className={classes.dialogTitle}>
        Radon Levels Guide
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid direction="column" container>
          <Grid item>
            <Box className={classes.imageContainer}>
              <img
                src={RadonLevelRangeImg}
                alt="Radon Level Range"
                className={classes.rangeImageTop}
              />
            </Box>
          </Grid>
          <Space height="20px" />
          <Grid item>
            <div className={classes.rangeContainer}>
              <img
                src={GreenRangeImg}
                alt="Green Range"
                className={classes.rangeIcon}
              />
              <div className={classes.rangeTextContainer}>
                <Typography className={classes.dialogContent}>
                  <span className={classes.rangeTitle}>Good</span> (0~2.6 pCi/L)
                </Typography>
                <Typography className={classes.bulletText}>
                  Your radon level is low. Continue monitoring your radon levels.
                </Typography>
              </div>
            </div>
            <div className={classes.rangeContainer}>
              <img
                src={OrangeRangeImg}
                alt="Orange Range"
                className={classes.rangeIcon}
              />
              <div className={classes.rangeTextContainer}>
                <Typography className={classes.dialogContent}>
                  <span className={classes.rangeTitle}>Moderate</span> (2.7~3.9 pCi/L)
                </Typography>
                <Typography className={classes.bulletText}>
                  Your radon level is moderately elevated. Track your long-term radon reading.
                </Typography>
              </div>
            </div>
            <div className={classes.rangeContainer}>
              <img
                src={RedRangeImg}
                alt="Red Range"
                className={classes.rangeIcon}
              />
              <div className={classes.rangeTextContainer}>
                <Typography className={classes.dialogContent}>
                  <span className={classes.rangeTitle}>High Risk</span> (4 pCi/L and above)
                </Typography>
                <Typography className={classes.bulletText}>
                  Your radon level is high. Take action and contact radon professional.
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={2}
          className={classes.buttonContainer}
        >
          <Grid item>
            <Button
              variant="outlined"
              className={classes.closeButton}
              onClick={handleClose}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Box>
  );
};

export default RadonLevelsGuideDialog;
